<script setup>

import { defineProps, defineEmits} from "vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "pedidoDeCompra",
    "email"
]);

const emits = defineEmits([
    "update:email"
]);

//==================================================================//
//======================== Altera Conteudo =========================//
//==================================================================//

const alteraConteudo = (conteudo) =>{

    emits('update:email',{
        conteudo: conteudo
    });

}

</script>

<template>

  <v-card
        class="c-corpo-email"
    >

        <v-card-title
            class="c-corpo-email__titulo"
        >
        
            <h3>Conteúdo</h3>

        </v-card-title>

        <div
            class="c-corpo-email__conteudo"
        >

            <v-textarea
                :value="props?.email?.conteudo"
                class="c-conteudo"
                label="Conteudo"
                variant="outlined"
                no-resize
                outlined
                auto-grow
                @input="alteraConteudo"
            >
            </v-textarea>

        </div>

    </v-card>

</template>

<style scoped>


</style>